import React from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { Col, Row } from '@ag1/ui';
import styles from './styles.module.scss';
import FooterMenu from '../FooterMenu/FooterMenu';
import FooterConnect from '../FooterConnect/FooterConnect';

const FooterContentMainTop = () => {
  const { pathname } = useRouter();
  const eduHubPaths = ['/content'];
  const isEduHubPaths = eduHubPaths.some((path) => pathname.match(path));

  return (
    <Row className={styles.row}>
      <Col span={{ xxs: 12, m: 6, l: 'auto' }} className={styles.col}>
        <FooterMenu />
      </Col>
      <Col
        span={{ xxs: 12, s: 8, m: 4, l: 'auto' }}
        offset={{ s: 2, l: 0 }}
        className={clsx(styles.connectCol, isEduHubPaths && styles.hideOnMobile)}>
        <div className={styles.connectColContent}>
          <FooterConnect />
        </div>
      </Col>
    </Row>
  );
};

export default FooterContentMainTop;
